import {NgModule} from '@angular/core';
import {CoreModule} from 'features/core/core.module';
import {CrCustomerBillingMapComponent} from './cr-customer-billing-map.component';
import {CrBillingMapCanvasDirective} from './canvas/cr-billing-map-canvas.directive';
import {CR_BILLING_MAP_DATA_SOURCE} from './data/cr-billing-map-data-source.token';
import {CrBillingMapQlDataSourceService} from './data/cr-billing-map-ql-data-source.service';

/**
 * AI:
 * Status: 'in progress'
 * Type: Module
 * SubType: Component module
 * Reason: Declares the Geldfluss map (`<cr-customer-billing-map>`) and its canvas directive, exports the map,
 *         and provides the standard data source (QL batch) behind `CR_BILLING_MAP_DATA_SOURCE`. The developer
 *         test page (route `cr/test/billingMap`) is NOT part of this module: `CrModule` declares it beside the
 *         other cr test pages.
 *
 *         WHY A MODULE OF ITS OWN: it keeps the `cr.module.ts` hunks of TM-1000002027 small (one import, one
 *         entry each in `imports` and `exports`, plus the test page declaration) next to the TM-1000002030
 *         hunks in the same file. `CrModule` imports and re-exports it.
 *
 *         It imports `CoreModule` ONLY (SharedModule with the PrimeNG surface) and must NEVER import `CrModule`:
 *         `CrModule` imports this module, so that would close a cycle (BOUND-002).
 *
 * @ticket TM-1000002027
 */
@NgModule({
    imports: [
        CoreModule
    ],
    declarations: [
        CrCustomerBillingMapComponent,
        CrBillingMapCanvasDirective
    ],
    exports: [
        CrCustomerBillingMapComponent
    ],
    providers: [
        {provide: CR_BILLING_MAP_DATA_SOURCE, useExisting: CrBillingMapQlDataSourceService}
    ]
})
export class CrCustomerBillingMapModule {
}
